import React from 'react';
import type { RenderError } from '@amzn/aws-tc-chatbot-ui';
import { ChatPanel } from './ChatPanel';
import { refreshToken } from '../../hooks/auth/useAuth';
import './IltLearnerAssistant.scss';
import {
    GUARDRAIL_BLOCKED_ERROR_CODE,
    ILT_LEARNER_ASSISTANT_AGENT_HEADER,
    ILT_LEARNER_ASSISTANT_AGENT_NAME,
    ILT_LEARNER_ASSISTANT_CONVERSATION_ID_STORAGE_KEY,
    ILT_LEARNER_ASSISTANT_ENDPOINT,
    ILT_LEARNER_ASSISTANT_FOOTER_LINES,
    ILT_LEARNER_ASSISTANT_FOOTER_LINKS,
    ILT_LEARNER_ASSISTANT_GUARDRAIL_BLOCKED_MESSAGE,
    ILT_LEARNER_ASSISTANT_HEADER_TITLE,
    ILT_LEARNER_ASSISTANT_WELCOME_MESSAGE,
} from './constants';

/**
 * ILT Learner Assistant — pre-configures the generic `<ChatPanel>` with the ILT
 * agent name, AG-UI endpoint, branding, and disclaimers. Renders `ChatbotV2` in
 * floating mode, which brings its own launcher button and draggable window, so
 * the host only needs to mount this once. The page loads with only the launcher
 * so the assistant does not cover course content until the learner asks for it.
 */
/**
 * Replaces the generic "Unable to complete response" copy when the AI Gateway's
 * guardrail blocks a message (the error arrives as `[GUARDRAIL_BLOCKED] ...`).
 * Other errors fall back to the library default.
 */
export const renderIltLearnerAssistantError: RenderError = (turn) =>
    turn.error.message.includes(GUARDRAIL_BLOCKED_ERROR_CODE) ? <span>{ILT_LEARNER_ASSISTANT_GUARDRAIL_BLOCKED_MESSAGE}</span> : undefined;

export const IltLearnerAssistantPanel = () => {
    return (
        <ChatPanel
            agentName={ILT_LEARNER_ASSISTANT_AGENT_NAME}
            endpoint={ILT_LEARNER_ASSISTANT_ENDPOINT}
            agentHeaderName={ILT_LEARNER_ASSISTANT_AGENT_HEADER}
            mode='floating'
            defaultOpen={false}
            headerTitle={ILT_LEARNER_ASSISTANT_HEADER_TITLE}
            welcomeMessage={ILT_LEARNER_ASSISTANT_WELCOME_MESSAGE}
            footerLines={ILT_LEARNER_ASSISTANT_FOOTER_LINES}
            footerLinks={ILT_LEARNER_ASSISTANT_FOOTER_LINKS}
            conversationIdStorageKey={ILT_LEARNER_ASSISTANT_CONVERSATION_ID_STORAGE_KEY}
            renderError={renderIltLearnerAssistantError}
            onEnsureAuth={async () => {
                // Renew the Gandalf/Cognito auth cookie before opening the stream so a
                // token that lapsed since the last visit doesn't fail the first message.
                await refreshToken();
            }}
        />
    );
};
